var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Send-Test-Email-Modal", { ref: "SendTestEmailModal" }),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "b-card",
            {
              staticStyle: { "margin-top": "0px", "border-bottom": "0px" },
              attrs: { title: "Card Title", "no-body": "" },
            },
            [
              _c(
                "b-card-header",
                { attrs: { "header-tag": "nav" } },
                [
                  _c(
                    "b-nav",
                    { attrs: { "card-header": "", tabs: "" } },
                    [
                      _c("b-nav-item", { attrs: { active: "" } }, [
                        _vm._v("System Emails"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-card-body", { staticClass: "text-center" }, [
                _c(
                  "div",
                  [
                    _c(
                      "b-card",
                      { attrs: { "bg-variant": "light" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "mb-0",
                            attrs: {
                              "label-cols-lg": "3",
                              label: "Confirmation Email",
                              "label-size": "lg",
                              "label-class": "font-weight-bold pt-0",
                            },
                          },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  "label-cols-sm": "3",
                                  label: "Subject:",
                                  "label-align-sm": "right",
                                  "label-for": "subject",
                                  description:
                                    "This is the subject line guests will see for this email.",
                                },
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "subject",
                                    placeholder: `Your booking confirmation with ${this.getVendor.name}`,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  "label-cols-sm": "3",
                                  label: "Reply-To:",
                                  "label-align-sm": "right",
                                  "label-for": "replyto",
                                  description:
                                    "If guests reply to this email, their email will be sent here. This email is set on Information page.",
                                },
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "replyto",
                                    placeholder: `${this.getVendor.email}`,
                                    disabled: "",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  "label-cols-sm": "3",
                                  label: "Body:",
                                  "label-align-sm": "right",
                                  "label-for": "body",
                                  description:
                                    "Here will be a quick guide for how to use the {{}} tags thoughout the email template maybe we link out to another dedicated page with further descriptions and details for more help Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
                                },
                              },
                              [
                                _c("b-form-textarea", {
                                  attrs: {
                                    id: "body",
                                    type: "text",
                                    rows: "6",
                                    placeholder:
                                      "Enter the email text with appropriate tags here",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                value:
                                  "This will send a test email VENDOREMAIL",
                                expression:
                                  "'This will send a test email VENDOREMAIL'",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            attrs: { type: "submit", variant: "secondary" },
                            on: { click: _vm.triggerEmailTestModal },
                          },
                          [
                            _vm._v(
                              "\n              Send Test Email\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                value: "Save Changes",
                                expression: "'Save Changes'",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            staticStyle: { float: "right" },
                            attrs: { type: "submit", variant: "success" },
                          },
                          [_vm._v("Save")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "b-card",
                      { attrs: { "bg-variant": "light" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "mb-0",
                            attrs: {
                              "label-cols-lg": "3",
                              label: "Invoice Email",
                              "label-size": "lg",
                              "label-class": "font-weight-bold pt-0",
                            },
                          },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  "label-cols-sm": "3",
                                  label: "Email Subject:",
                                  "label-align-sm": "right",
                                  "label-for": "nested-street",
                                  description:
                                    "This is the subject line the guest will see when an email comes to them, we recommend using VENDORNAMETAG to display your hotel name in the subject line",
                                },
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "nested-street",
                                    placeholder:
                                      "Your booking confirmation with VendorName",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  "label-cols-sm": "3",
                                  label: "Email Reply-To:",
                                  "label-align-sm": "right",
                                  "label-for": "nested-city",
                                  description:
                                    "This email is set in the Hotel Information page. This email will be used when a guest click 'reply-to'.",
                                },
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "nested-city",
                                    placeholder: "vendor@vendoremail.com",
                                    disabled: "",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  "label-cols-sm": "3",
                                  label: "Email Body:",
                                  "label-align-sm": "right",
                                  "label-for": "nested-city",
                                  description:
                                    "Here will be a quick guide for how to use the {{}} tags thoughout the email template maybe we link out to another dedicated page with further descriptions and details for more help Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
                                },
                              },
                              [
                                _c("b-form-textarea", {
                                  attrs: {
                                    id: "nested-city",
                                    type: "text",
                                    rows: "6",
                                    placeholder:
                                      "Enter the email text with appropriate tags here",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                value:
                                  "This will send a test email VENDOREMAIL",
                                expression:
                                  "'This will send a test email VENDOREMAIL'",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            attrs: { type: "submit", variant: "secondary" },
                          },
                          [_vm._v("Send Test Email")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                value: "Save Changes",
                                expression: "'Save Changes'",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            staticStyle: { float: "right" },
                            attrs: { type: "submit", variant: "success" },
                          },
                          [_vm._v("Save")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }